import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import { CircularProgress, Link } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

interface DialogResultProps {
  open: boolean;
  mergeRequests: string[];
  errorMessage: string | undefined;
  onClose: () => void;
}

export function DialogResult(props: Readonly<DialogResultProps>) {
  const [mergeRequests, setMergeRequests] = useState<string[]>([]);
  const [errorMessage, setErrorMessage] = useState<string | undefined>();

  useEffect(() => {
    setMergeRequests(props.mergeRequests);
  }, [props.mergeRequests]);

  useEffect(() => {
    setErrorMessage(props.errorMessage);
  }, [props.errorMessage]);

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogTitle>Result</DialogTitle>
      <DialogContent>
        {mergeRequests.length === 0 && !errorMessage && (
          <>
            <p>Please wait until all merge requests are prepared!</p>
            <CircularProgress />
          </>
        )}
        {mergeRequests.length !== 0 && (
          <>
            <p>Please merge the following merge requests:</p>
            <ul>
              {mergeRequests.map(it => (
                <li key={it}>
                  <Link href={it} target="_blank">
                    {it}
                  </Link>
                </li>
              ))}
            </ul>
            <Alert severity="info">
              All changes in this digramm have disapeared an placed into the
              above merge requests.
              <br />
              Your changes will appear again about one or two hours after
              merging all merge request.
            </Alert>
          </>
        )}
        {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
}
